import { render, staticRenderFns } from "./addPatientLayout.vue?vue&type=template&id=4e2f88f8&scoped=true"
import script from "./addPatientLayout.vue?vue&type=script&lang=js"
export * from "./addPatientLayout.vue?vue&type=script&lang=js"
import style0 from "./addPatientLayout.vue?vue&type=style&index=0&id=4e2f88f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f88f8",
  null
  
)

export default component.exports